export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14816.0267bed3.jpg";